module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmhead"
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("The author would like to extend his sincere thanks for the help in preparation of this book to the following individuals (in Russian alphabetical order): A. Arkhipov, M. Baryatinskiy, G. Gagin, M. Khairulin, A. Kirindas, M. Kolomiets, O. Leonov, M. Maslov, M. Muratov, G. Petrov, V. Rigmant, G. Sloutskiy, S. Chmelyuk, A. Yugenson and N. Yakubovich.")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30bd1f37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Acknowledgements.vue
// module id = 72
// module chunks = 0